const DESKTOP_QUERY = '(min-width: 750px)';

class DarkrimAboutMedia extends HTMLElement {
  #desktopMediaQuery = window.matchMedia(DESKTOP_QUERY);

  connectedCallback() {
    this.#desktopMediaQuery.addEventListener('change', this.#handleViewportChange);
    this.#syncVideos();
  }

  disconnectedCallback() {
    this.#desktopMediaQuery.removeEventListener('change', this.#handleViewportChange);
  }

  #syncVideos() {
    const viewport = this.#desktopMediaQuery.matches ? 'pc' : 'mobile';

    // Clone only the active viewport's deferred-media tree so the hidden video never requests data.
    this.querySelectorAll('[data-darkrim-about-media-frame]').forEach((mediaFrame) => {
      const host = mediaFrame.querySelector('[data-darkrim-about-media-video-host]');
      if (!(host instanceof HTMLElement)) return;

      const mode = mediaFrame.dataset[`${viewport}Mode`];
      if (mode !== 'video') {
        host.replaceChildren();
        delete host.dataset.viewport;
        return;
      }

      if (host.dataset.viewport === viewport && host.firstElementChild) return;

      const template = mediaFrame.querySelector(
        `[data-darkrim-about-media-video-template="${viewport}"]`
      );
      if (!(template instanceof HTMLTemplateElement)) return;

      host.replaceChildren(template.content.cloneNode(true));
      host.dataset.viewport = viewport;
    });
  }

  #handleViewportChange = () => {
    this.#syncVideos();
  };
}

if (!customElements.get('darkrim-about-media')) {
  customElements.define('darkrim-about-media', DarkrimAboutMedia);
}
